import styled, { css } from 'styled-components';
import { COLOR_GREEN, COLOR_BLACK } from '../../../../../assets/styles/colors';
import { rgba } from 'polished';

export const StateCheckboxSC = styled.button`
  width: 20px;
  height: 20px;
  border: 1px solid transparent;
  border-radius: 10px;
  margin: 0;

  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;

  font-weight: bold;

  ${({ state }) => {
    if (state === 'partial' || state === 'all') {
      return css`
        color: white;
        background: ${COLOR_GREEN};
        border-color: ${COLOR_GREEN};
      `;
    }

    return css`
      border-color: ${rgba(COLOR_BLACK, 0.2)};
      background: white;
    `;
  }}
`;
